import DateAndOrTimePickerViewModelBase from '@/ViewModels/Controls/DateAndOrTimePickerViewModelBase';
import * as DateHelper from '@/Utility/DateHelper';

import {IDatePickerViewModelConstructorParameter} from "#/DefaultViewExtensionInterfaces";

export default class DatePickerViewModelBase extends DateAndOrTimePickerViewModelBase {

    /**
     * Das minimal auswaehlbare Datum im DatePicker
     */
    public min: KnockoutObservable<Date>;

    /**
     * Das maximal auswaehlbare Datum im DatePicker
     */
    public max: KnockoutObservable<Date>;

    /**
     * Das Date-Objekt als String im Format der aktuellen Sprache
     */
    public dateString: KnockoutComputed<string>;

    public constructor(params: IDatePickerViewModelConstructorParameter) {
        super(params);
        const minDateTime = this.observableOrDefault<Date>(params.min, new Date(1900, 0, 1));
        this.min = this.defineComputed({
            read() {
                const date = minDateTime();
                // ungewollte Zeitangaben vom min Datum entfernen, sonst kann in einem DatePicker (ohne Moeglichkeit eine Zeit einzugeben) der erste Tag nicht ausgewaehlt werden
                date.setHours(0, 0, 0, 0);
                return date;
            },
            write(value) {
                minDateTime(value);
            }
        });
        this.max = this.observableOrDefault(params.max, new Date(2099, 11, 31, 23, 59));
        this.dateString = this.defineComputed(() => {
            const date = this.date();
            const value = DateHelper.toString(date);
            return value;
        });
    }

    public customValidate(value: string, isNullableType: boolean): boolean {
        if (!this.validity())
            return false;

        const date = DateHelper.parseDotNetDateTimeString(value);

        if (!date)
            return isNullableType;

        const max = this.max();
        const min = this.min();

        return date >= min && date <= max;
    }

    public canReset(): boolean {
        return !String.isNullOrEmpty(this.rawValue()) || !this.validity();
    }
}
